<template>
  <div class="container mt-5">
    <h1>[PREVENTIVA] SERVIÇO REALIZADO</h1>
    <b-button @click="openCreateModal" class="mb-4" size="sm" variant="primary">
      Adicionar Registro
    </b-button>

    <b-modal
      v-model="openModal"
      :title="
        isEditMode ? 'Editar Serviço Realizado' : 'Registrar Serviço Realizado'
      "
      @hide="onModalHide"
      @shown="focusFirstInput"
      hide-footer
    >
      <RevisionDoneCreate
        :model="currentRevision"
        :is-edit-mode="isEditMode"
        @success="handleSuccess"
        @close="closeModal"
      />
    </b-modal>

    <b-table :items="revisionsDone" :fields="fields" responsive class="mt-4">
      <template #cell(actions)="data">
        <b-button
          size="sm"
          variant="secondary"
          @click="openEditModal(data.item)"
          class="mr-2"
        >
          Editar
        </b-button>
        <b-button size="sm" variant="danger" @click="deleteRevision(data.item)">
          Deletar
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import RevisionDoneCreate from "../../../../components_rms/vehicle/Revision/RevisionDoneCreate.vue";

export default {
  components: {
    RevisionDoneCreate
  },
  data() {
    return {
      openModal: false,
      revisionsDone: [],
      isEditMode: false,
      currentRevision: {
        vehicleId: null,
        companyId: 0,
        plate: "",
        measurer: 0,
        vehicleRevisionId: null,
        description: "",
        revisionType: 0,
        reviewDate: "",
        exitDate: "",
        entryId: null,
        exitId: null
      },
      fields: [
        { key: "description", label: "Descrição" },
        { key: "plate", label: "Placa" },
        { key: "measurer", label: "Marcador" },
        { key: "vehicleRevisionId", label: "Id da Revisão" },
        { key: "actions", label: "Ações", sortable: false }
      ]
    };
  },
  mounted() {
    this.fetchRevisions();
  },
  methods: {
    openCreateModal() {
      this.isEditMode = false;
      this.currentRevision = {
        vehicleId: null,
        companyId: 0,
        plate: "",
        measurer: 0,
        vehicleRevisionId: null,
        description: "",
        revisionType: 0,
        reviewDate: "",
        exitDate: "",
        entryId: null,
        exitId: null
      };
      this.openModal = true;
    },
    openEditModal(revision) {
      this.isEditMode = true;
      this.currentRevision = { ...revision };
      this.openModal = true;
    },
    closeModal() {
      this.openModal = false;
    },

    async fetchRevisions() {
      try {
        const response = await this.$apiVehicle.get("/GetAllRevisionDones/");
        this.revisionsDone = response.data;
      } catch (error) {
        console.error("Erro ao buscar manutenções:", error);
      }
    },
    handleSuccess() {
      this.openModal = false;
      this.fetchRevisions();
    },

    onModalHide() {
      this.isEditMode = false;
      this.currentRevision = {
        vehicleId: null,
        companyId: 0,
        plate: "",
        measurer: 0,
        vehicleRevisionId: null,
        description: "",
        revisionType: 0,
        reviewDate: "",
        exitDate: "",
        entryId: null,
        exitId: null
      };
    },
    async deleteRevision(revision) {
      try {
        await this.$apiVehicle.post(`/DeleteRevisionDone/`, revision);
        this.fetchRevisions();
      } catch (error) {
        console.error("Erro ao deletar revisão:", error);
      }
    },
    focusFirstInput() {
      this.$nextTick(() => {
        const firstInput = this.$el.querySelector("input");
        if (firstInput) firstInput.focus();
      });
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 800px;
}
.table th,
.table td {
  text-align: center;
}
.form-group {
  margin-bottom: 15px;
}
</style>
